import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Provider, ProviderCategories } from '../../../../types';
import { toast } from 'react-toastify';
import { getProviderByProviderId } from '../../../../../../../../crud/management_api/providers';

interface UnassignCategoryProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  provider: Provider;
  category: ProviderCategories;
  onSuccess: (updatedProvider: Provider) => void;
}

const UnassignCategory: React.FC<UnassignCategoryProps> = ({
  showModal,
  setShowModal,
  provider,
  category,
  onSuccess
}) => {
  const handleUnassign = async () => {
    try {
      // Import the unassign function dynamically to avoid circular dependencies
      const { unassignCategoriesFromProvider } = await import('../../../../../../../../crud/management_api/providers');
      
      await unassignCategoriesFromProvider(Number(provider.provider_id), [Number(category.category_id)]);
      toast.success(`Categoría "${category.name}" desasignada correctamente`);
      
      // Fetch updated provider data
      const response: any = await getProviderByProviderId(String(provider.provider_id));
      onSuccess(response.data);
      setShowModal(false);
    } catch (error: any) {
      console.error('Error al desasignar categoría:', error);
      toast.error(error?.response?.data?.message || 'Error al desasignar la categoría');
    }
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>
            Desasignar categoría
          </Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={() => setShowModal(false)}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas desasignar la categoría <strong>"{category.name}"</strong> del proveedor <strong>"{provider.name}"</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button className="form-button-delete" onClick={handleUnassign}>
            Desasignar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UnassignCategory;
